import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

declare var jQuery: any;

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-carousel',
	styleUrls: ['./carousel.component.css'],
	templateUrl: './carousel.component.html'
})
export class CarouselComponent implements OnInit, OnChanges {
	@Input() data: any;
	@Input() title: any;
	@Input() slideClassNames: any;
	@Input() placeholderImage: any;
	carouselItemsLength: number;

	setDisplayProperties: any = {};
	getDisplayIndex: any;

	constructor() {}

	ngOnInit(): void {
		this.getDisplayIndex = this.data.length - 1;
		this.carouselItemsLength = this.data.length;
		this.setSlide();
		this.setDisplayIndexContent(this.getDisplayIndex);
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.getDisplayIndex = this.data.length - 1;
		this.carouselItemsLength = this.data.length;
		this.setSlide();
		this.setDisplayIndexContent(this.getDisplayIndex);
	}

	setSlide(): void {
		// tslint:disable-next-line: prefer-template
		jQuery('.' + this.slideClassNames.ClassName + ' img:gt(0)').hide();
		this.nextArrow();
		this.prevArrow();
	}

	setDisplayIndexContent(getDisplayIndex: any): void {
		if (this.data.length === 0) {
			this.setDisplayProperties = {
				ad_interactions: 0,
				click_rate: 0,
				clicks: 0,
				completion: 0,
				completion_rate: 0,
				impressions: 0,
				interaction_rate: 0,
				name: '',
				thumbnail: ''
			};
		} else {
			let setImpressions = this.data[getDisplayIndex].impressions;
			let setAd_interactions = this.data[getDisplayIndex].ad_interactions;
			let setInteraction_rate = this.data[getDisplayIndex].interaction_rate;
			let setClicks = this.data[getDisplayIndex].clicks;
			let setClick_rate = this.data[getDisplayIndex].click_rate;
			let setCompletion;
			let setCompletionRate;
			if (setImpressions == null || setImpressions === '') {
				setImpressions = 0;
			}
			if (setAd_interactions == null || setAd_interactions === '') {
				setAd_interactions = 0;
			}
			if (setInteraction_rate == null || setInteraction_rate === '') {
				setInteraction_rate = 0;
			}
			if (setClicks == null || setClicks === '') {
				setClicks = 0;
			}
			if (setClick_rate == null || setClick_rate === '') {
				setClick_rate = 0;
			}
			setClick_rate = parseFloat(setClick_rate).toFixed(2);
			setInteraction_rate = parseFloat(setInteraction_rate).toFixed(2);
			if (this.title === 'Pre Roll') {
				setCompletion = this.data[getDisplayIndex]['100_percent_value'];
				setCompletionRate = this.data[getDisplayIndex]['100_percent_rate'];
				setCompletionRate = parseFloat(setCompletionRate).toFixed(2);
			} else {
				setCompletion = 0;
				setCompletionRate = 0;
			}
			this.setDisplayProperties = {
				ad_interactions: setAd_interactions,
				click_rate: setClick_rate,
				clicks: setClicks,
				completion: setCompletion,
				completion_rate: setCompletionRate,
				impressions: setImpressions,
				interaction_rate: setInteraction_rate,
				name: this.data[getDisplayIndex].name,
				thumbnail: this.data[getDisplayIndex].thumbnail
			};
		}
	}

	nextArrow(): void {
		if (this.data.length > 1) {
			if (this.getDisplayIndex === 0) {
				this.getDisplayIndex = this.data.length - 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			}
		}
	}

	prevArrow(): void {
		if (this.data.length > 1) {
			if (this.data.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
				this.setDisplayIndexContent(this.getDisplayIndex);
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
				this.setDisplayIndexContent(this.getDisplayIndex);
			}
		}
	}
}
